// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2eW6O","item":"PaymentsMobile_item__Cvl1Y","label":"PaymentsMobile_label__zfA1n","amount":"PaymentsMobile_amount__1Q0hM"};